/* ALCOBA — global.js (vanilla, sin dependencias) */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

  /* ---------- Age gate ---------- */
  const gate = $('#AgeGate');
  if (gate) {
    const KEY = 'alcoba_age_ok';
    const ok = () => {
      try {
        const v = JSON.parse(localStorage.getItem(KEY));
        return v && Date.now() < v.exp;
      } catch (e) { return false; }
    };
    if (!ok()) {
      gate.classList.add('is-open');
      document.body.classList.add('age-gate-locked');
      $('#AgeGateYes').addEventListener('click', () => {
        try { localStorage.setItem(KEY, JSON.stringify({ exp: Date.now() + 30 * 864e5 })); } catch (e) {}
        gate.classList.remove('is-open');
        document.body.classList.remove('age-gate-locked');
      });
      const no = $('#AgeGateNo');
      if (no) no.addEventListener('click', () => { window.location.href = no.dataset.exit || 'https://www.google.com'; });
    }
  }

  /* ---------- Header sombra al hacer scroll ---------- */
  const headerWrap = $('.header-wrapper');
  if (headerWrap) {
    const onScroll = () => headerWrap.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement bar rotatoria ---------- */
  const annItems = $$('.announcement__item');
  if (annItems.length > 1) {
    let i = 0;
    setInterval(() => {
      annItems[i].classList.remove('is-active');
      i = (i + 1) % annItems.length;
      annItems[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- Drawers (menú y carrito) ---------- */
  function bindDrawer(drawerId, openSel) {
    const drawer = $(drawerId);
    if (!drawer) return;
    const open = () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; const f = $('button, a, input', drawer); if (f) f.focus({ preventScroll: true }); };
    const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    $$(openSel).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    $$('.drawer__overlay, [data-drawer-close]', drawer).forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    drawer._open = open; drawer._close = close;
  }
  bindDrawer('#MenuDrawer', '[data-open-menu]');
  bindDrawer('#CartDrawer', '[data-open-cart]');
  bindDrawer('#FilterDrawer', '[data-open-filters]');

  /* ---------- Buscador predictivo ---------- */
  const searchModal = $('#SearchModal');
  if (searchModal) {
    const input = $('#SearchInput');
    const results = $('#PredictiveResults');
    $$('[data-open-search]').forEach(b => b.addEventListener('click', () => {
      searchModal.classList.add('is-open'); document.body.style.overflow = 'hidden'; input.focus({ preventScroll: true });
    }));
    const close = () => { searchModal.classList.remove('is-open'); document.body.style.overflow = ''; };
    searchModal.addEventListener('click', (e) => { if (e.target === searchModal) close(); });
    $$('[data-search-close]', searchModal).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor`);
          const data = await res.json();
          const products = data.resources.results.products || [];
          results.innerHTML = products.length
            ? products.map(p => `
              <a class="predictive-item" href="${p.url}">
                ${p.image ? `<img src="${p.image}&width=104" width="52" height="52" alt="" loading="lazy">` : ''}
                <div><div class="predictive-item__title">${p.title}</div>
                <div class="predictive-item__price">${p.price}</div></div>
              </a>`).join('')
            : '<p style="font-size:.9rem;color:var(--color-texto-suave);padding:.5rem">Sin resultados. Pulsa Enter para buscar en toda la tienda.</p>';
        } catch (e) { results.innerHTML = ''; }
      }, 250);
    });
  }

  /* ---------- Carrito AJAX ---------- */
  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    $$('.cart-count').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const itemsBox = $('#CartDrawerItems');
    const emptyBox = $('#CartDrawerEmpty');
    const footBox = $('#CartDrawerFooter');
    if (itemsBox) {
      if (cart.item_count === 0) {
        itemsBox.innerHTML = '';
        if (emptyBox) emptyBox.hidden = false;
        if (footBox) footBox.hidden = true;
      } else {
        if (emptyBox) emptyBox.hidden = true;
        if (footBox) footBox.hidden = false;
        itemsBox.innerHTML = cart.items.map(it => `
          <div class="cart-item">
            <span class="cart-item__media">${it.image ? `<img class="ac-blend" src="${it.image.replace(/(\.[a-z]+)(\?|$)/, '$1?width=160$2')}" alt="" width="80" height="80" loading="lazy">` : ''}</span>
            <div class="cart-item__info">
              <a class="cart-item__title" href="${it.url}">${it.product_title}</a>
              ${it.variant_title ? `<div class="cart-item__meta">${it.variant_title}</div>` : ''}
              <div class="cart-item__actions">
                <input class="cart-item__qty" type="number" inputmode="numeric" min="0" value="${it.quantity}" data-cart-qty="${it.key}" aria-label="Cantidad">
                <button class="cart-item__remove" type="button" data-cart-remove="${it.key}">Eliminar</button>
              </div>
            </div>
            <div class="cart-item__price ac-price">${money(it.final_line_price)}</div>
          </div>`).join('');
      }
      const subtotal = $('#CartSubtotal');
      if (subtotal) subtotal.textContent = money(cart.total_price);
    }
    updateShippingBar(cart.total_price);
    bindCartEvents();
    return cart;
  }

  function updateShippingBar(total) {
    const bar = $('.free-shipping-bar');
    if (!bar) return;
    const threshold = window.themeSettings.freeShippingThreshold;
    if (!threshold) { bar.hidden = true; return; }
    const fill = $('.free-shipping-bar__fill', bar);
    const label = $('p', bar);
    const pct = Math.min(100, (total / threshold) * 100);
    fill.style.width = pct + '%';
    label.textContent = total >= threshold
      ? window.themeStrings.freeShippingReached
      : window.themeStrings.freeShippingRemaining.replace('{{ amount }}', money(threshold - total));
  }

  function bindCartEvents() {
    $$('[data-cart-remove]').forEach(btn => btn.addEventListener('click', async () => {
      btn.disabled = true;
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.cartRemove, quantity: 0 })
      });
      refreshCart();
    }));
    $$('[data-cart-qty]').forEach(inp => inp.addEventListener('change', async () => {
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: inp.dataset.cartQty, quantity: parseInt(inp.value, 10) || 0 })
      });
      refreshCart();
    }));
  }
  bindCartEvents();
  fetch('/cart.js').then(r => r.json()).then(c => updateShippingBar(c.total_price)).catch(() => {});

  async function addToCart(id, qty, btn) {
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: qty || 1 })
      });
      if (!res.ok) throw new Error();
      if (btn) btn.textContent = window.themeStrings.added;
      await refreshCart();
      const cartDrawer = $('#CartDrawer');
      if (cartDrawer && cartDrawer._open) cartDrawer._open();
    } catch (e) {
      alert(window.themeStrings.cartError);
    } finally {
      if (btn) setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1400);
    }
  }

  /* Quick add en tarjetas (solo productos de variante única) */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.quickAdd, 1, btn);
  });

  /* ---------- Formulario de producto ---------- */
  const productForm = $('#ProductForm');
  if (productForm) {
    const json = $('#ProductJson');
    const product = json ? JSON.parse(json.textContent) : null;
    const idInput = $('input[name="id"]', productForm);
    const priceBox = $('#ProductPrice');
    const atcBtn = $('#AddToCart');
    const stickyPrice = $('#StickyPrice');

    function currentVariant() {
      if (!product) return null;
      const opts = $$('.variant-options input:checked', productForm).map(i => i.value);
      return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }

    function renderPrice(v) {
      if (!v) return;
      let html = '';
      if (v.compare_at_price > v.price) html += `<s class="price__compare">${money(v.compare_at_price)}</s>`;
      html += `<span>${money(v.price)}</span>`;
      if (priceBox) priceBox.innerHTML = html;
      if (stickyPrice) stickyPrice.innerHTML = html;
    }

    function onVariantChange() {
      const v = currentVariant();
      if (!v) {
        atcBtn.disabled = true; atcBtn.textContent = window.themeStrings.soldOut; return;
      }
      idInput.value = v.id;
      renderPrice(v);
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      if (v.featured_media && v.featured_media.preview_image) setMainImage(v.featured_media.preview_image.src);
    }
    $$('.variant-options input', productForm).forEach(i => i.addEventListener('change', onVariantChange));

    /* Cantidad */
    const qtyInput = $('.qty input', productForm);
    $$('.qty button', productForm).forEach(b => b.addEventListener('click', () => {
      const d = b.dataset.qty === 'plus' ? 1 : -1;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
    }));

    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(idInput.value, parseInt(qtyInput.value, 10) || 1, atcBtn);
    });
    const stickyBtn = $('#StickyAtc');
    if (stickyBtn) stickyBtn.addEventListener('click', () => addToCart(idInput.value, parseInt(qtyInput.value, 10) || 1, stickyBtn));

    /* Galería */
    const mainImg = $('#MainProductImage');
    function setMainImage(src) {
      if (!mainImg) return;
      mainImg.src = src.includes('?') ? src : src + '?width=1200';
      $$('.product__thumb').forEach(t => t.classList.toggle('is-active', t.dataset.full === src));
    }
    $$('.product__thumb').forEach(t => t.addEventListener('click', () => setMainImage(t.dataset.full)));
    if (mainImg) mainImg.addEventListener('click', () => mainImg.classList.toggle('is-zoomed'));

    /* Barra sticky móvil */
    const sticky = $('.sticky-atc');
    if (sticky && atcBtn) {
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { rootMargin: '-80px' });
      io.observe(atcBtn);
    }
  }

  /* ---------- Favoritos (wishlist) — 100% local, sin apps de terceros ---------- */
  const WISHLIST_KEY = 'alcoba_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    renderWishlist();
  }
  function renderWishlist() {
    const list = getWishlist();
    $$('#WishlistCount').forEach(el => { el.textContent = list.length; el.dataset.count = list.length; });
    $$('[data-wishlist-toggle]').forEach(btn => {
      btn.classList.toggle('is-active', list.some(i => i.id === btn.dataset.id));
    });
    const box = $('#WishlistItems');
    if (!box) return;
    box.innerHTML = list.length
      ? list.map(i => `
        <div class="wishlist-item">
          <img src="${i.image}" alt="" width="64" height="64" loading="lazy">
          <div><a class="wishlist-item__title" href="${i.url}">${i.title}</a><div>${i.price}</div>
          <button class="wishlist-item__remove" type="button" data-wishlist-remove="${i.id}">Quitar</button></div>
        </div>`).join('')
      : '<p style="text-align:center;color:var(--color-texto-suave);padding:2rem 0">Aún no has guardado nada. Toca el corazón de un producto para añadirlo aquí.</p>';
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-wishlist-toggle]');
    if (t) {
      e.preventDefault();
      const list = getWishlist();
      const idx = list.findIndex(i => i.id === t.dataset.id);
      if (idx > -1) list.splice(idx, 1);
      else list.push({ id: t.dataset.id, title: t.dataset.title, url: t.dataset.url, price: t.dataset.price, image: t.dataset.image });
      setWishlist(list);
      return;
    }
    const r = e.target.closest('[data-wishlist-remove]');
    if (r) { setWishlist(getWishlist().filter(i => i.id !== r.dataset.wishlistRemove)); }
  });
  bindDrawer('#WishlistDrawer', '[data-open-wishlist]');
  renderWishlist();

  /* ---------- Filtros: autosubmit ---------- */
  const facetForm = $('#FacetsForm');
  if (facetForm) {
    facetForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type=checkbox], select')) facetForm.submit();
    });
  }
  const sortSelect = $('#SortBy');
  if (sortSelect) sortSelect.addEventListener('change', () => {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location = url;
  });
})();
